import "bootstrap"
import "./assets/global.scss"
import {createApp} from 'vue'
import App from './App.vue'
import {store} from './store'
import CardsGroup from "@/components/CardsGroup"
import {createRouter, createWebHashHistory} from 'vue-router'
import {Tooltip} from "@programic/vue3-tooltip"
import '@programic/vue3-tooltip/dist/index.css'
import CKEditor from '@ckeditor/ckeditor5-vue'
import PrimeVue from 'primevue/config';
import axios from "axios";


const routes = [
    {
        path: '/',
        name: 'template',
        component: CardsGroup,
        props: true,
    },
]
const router = createRouter (
    {
        history: createWebHashHistory(),
        routes,
    })

const app = createApp(App)
app.use(store)
app.use(router)
app.use(Tooltip)
app.use(CKEditor)
app.use(PrimeVue)
app.mount('#app')

const token = localStorage.getItem('token')
if (token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

router.beforeResolve(async (to, from, next) => {
//    store.dispatch('checkQuery', to.query).then(()=>{})

    next()
})
